import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// Import styles
import './assets/scss/themes.scss';

// Import Routes
import Route from './Routes';

// Fake Backend
import fakeBackend from "./helpers/AuthType/fakeBackend";
fakeBackend();

// Create a client instance
const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <React.Fragment>
        <Route />
      </React.Fragment>
    </QueryClientProvider>
  );
}

export default App;
